var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVersionNameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 0C7.39704 0 6.85671 0.369641 6.63871 0.931641L0.494178 16.7305C0.256178 17.3415 0.706366 18 1.36137 18C1.74537 18 2.09051 17.7642 2.23051 17.4062L4.33207 12H11.668L13.7696 17.4043C13.9086 17.7633 14.2537 18 14.6387 18C15.2937 18 15.7439 17.3415 15.5059 16.7305L9.36137 0.931641C9.14337 0.369641 8.60304 0 8.00004 0ZM8.00004 2.57031L10.8907 10H5.11137L8.00004 2.57031Z",
    fill: "#265183"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersionNameIcon);
export default __webpack_public_path__ + "static/media/version-name-icon.1fae1fa8c2ec7b0c8c446069253c14db.svg";
export { ForwardRef as ReactComponent };